import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import styles from './styles.css'

const Header = props => {

  const {
    subOrder,
    onClickApprove,
    onClickReject,
  } = props

  // Hide buttons if order is approved (status_key 3) or rejected (status_key 4)
  const showButtons = subOrder.status_key !== 3 && subOrder.status_key !== 4

  return (

    <div className={styles.wrapper}>

      <h1 className={styles.header}>{subOrder.reference}</h1>

      {showButtons && (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button type='primary' icon={<CheckOutlined />} onClick={onClickApprove}>
            Approve
          </Button>
          <Button danger icon={<CloseOutlined />} onClick={onClickReject}>
            Reject
          </Button>
        </div>
      )}

    </div>

  )

}

Header.propTypes = {
  subOrder: PropTypes.object.isRequired,
  onClickApprove: PropTypes.func.isRequired,
  onClickReject: PropTypes.func.isRequired,
}

export default Header
